import { ReactNode, useState } from 'react';
import { useAtomValue } from 'jotai';
import { NotificationBell } from '~/components/ui/layout/page/NotificationBell';
import { UserWidget } from '~/components/ui/layout/page/UserWidget';
import { FeedbackDialog } from '~/components/ui/layout/page/FeedbackDialog';
import { HeaderMenu } from '~/components/ui/layout/page/HeaderMenu';
import { canAccess } from '~/utils/rbac';
import { EditPortfolioDialog } from '~/components/ui/common/EditPortfolioDialog';
import { portfolioIdAtom } from '~/atoms/dashboardAtom';
import { useSidebar } from '~/routes/_authLayout';

export const HeaderContainer = ({
  children,
  onResetLayout,
  onAddWidget,
  isDashboard = false,
}: {
  children: ReactNode;
  onResetLayout?: () => void;
  onAddWidget?: () => void;
  isDashboard?: boolean;
}) => {
  const portfolioId = useAtomValue(portfolioIdAtom);
  const [editPortfolioVisible, setEditPortfolioVisible] = useState(false);
  const [feedbackDialogVisible, setFeedbackDialogVisible] = useState(false);

  // Get sidebar state to adjust header position
  let sidebarWidth = 56; // default collapsed width
  try {
    const sidebar = useSidebar();
    sidebarWidth = sidebar.sidebarWidth;
  } catch {
    // If not in sidebar context, use default
  }

  return (
    <div
      className="header-container flex justify-content-between align-items-center"
      style={{
        left: `${sidebarWidth}px`,
        width: `calc(100% - ${sidebarWidth}px)`,
        paddingLeft: '0.75rem',
        paddingRight: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <div
        className="breadcrumb-container"
        style={{ flex: '0 1 auto', minWidth: 0, overflow: 'hidden' }}
      >
        {children}
      </div>
      <div
        className="header-actions"
        style={{
          flex: '0 0 auto',
          display: 'flex',
          gap: '0.75rem',
          marginLeft: 'auto',
          paddingRight: 0,
          minWidth: 0,
          width: 'auto',
        }}
      >
        <HeaderMenu
          onResetLayout={onResetLayout}
          onAddWidget={onAddWidget}
          onEditPortfolio={() => setEditPortfolioVisible(true)}
          onSendFeedback={() => setFeedbackDialogVisible(true)}
          isDashboard={isDashboard}
          portfolioId={portfolioId || undefined}
        />
        {canAccess('workflow') && <NotificationBell />}
        <UserWidget />
      </div>

      <EditPortfolioDialog
        visible={editPortfolioVisible}
        onHide={() => setEditPortfolioVisible(false)}
      />

      <FeedbackDialog
        visible={feedbackDialogVisible}
        onHide={() => setFeedbackDialogVisible(false)}
      />
    </div>
  );
};
